import { render, staticRenderFns } from "./AppraisalDetailsNew.vue?vue&type=template&id=3cc9988f&"
import script from "./AppraisalDetailsNew.vue?vue&type=script&lang=js&"
export * from "./AppraisalDetailsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports